module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Balance.js"));
	}, "Balance");
}